export default "__VITE_ASSET__CLM0iXS7__"